export default `---
slug: physics-excellence-school
type: extracurricular
dateRange: "Summer 2015"
institution: "University of Udine"
location: "Udine, Italy"
role: "Attendee — Physics School of Excellence"
current: false
sortKey: "2015-08"
skills: [Quantum Physics, Electromagnetism, Wave-Particle Duality, Experimental Physics]
relatedLinks:
  - label: "Liceo Scientifico"
    href: /career/liceo-scientifico
---

In the summer of 2015, before my final year of high school, I was selected to attend the Physics School of Excellence organized by the University of Udine. The school was open to only 40 students in the entire country, chosen through a rigorous selection process. It was one week full of university-level lectures and hands-on workshops on modern physics — dual nature of light, polarization, quantization, electromagnetism. Both theoretical and experimental activities, conducted alongside professors and researchers at the cutting edge of their fields. It was my first real taste of university-level science, and it confirmed that physics and engineering were exactly where I wanted to go.
`;
